export const GET_ICEPACK_FILLER_INFO = 'icepacks-fillers-modal/GET_ICEPACK_FILLER_INFO';
export const getIcepackFillerInfoAction = payload => ({
	type: GET_ICEPACK_FILLER_INFO,
	payload,
});

export const SET_ICEPACK_FILLER_INFO = 'icepacks-fillers-modal/SET_ICEPACK_FILLER_INFO';
export const setIcepackFillerInfoAction = payload => ({
	type: SET_ICEPACK_FILLER_INFO,
	payload,
});

export const SET_IS_ICEPACK_FILLER_INFO_LOADING = 'icepacks-fillers-modal/SET_IS_ICEPACK_FILLER_INFO_LOADING';
export const setIsIcepackFillerInfoLoadingAction = payload => ({
	type: SET_IS_ICEPACK_FILLER_INFO_LOADING,
	payload,
});

export const CREATE_ICEPACK_FILLER = 'icepacks-fillers-modal/CREATE_ICEPACK_FILLER';
export const createIcepackFillerAction = payload => ({
	type: CREATE_ICEPACK_FILLER,
	payload,
});

export const SET_IS_ICEPACK_FILLER_CREATING = 'icepacks-fillers-modal/SET_IS_ICEPACK_FILLER_CREATING';
export const setIsIcepackFillerCreatingAction = payload => ({
	type: SET_IS_ICEPACK_FILLER_CREATING,
	payload,
});

export const UPDATE_ICEPACK_FILLER = 'icepacks-fillers-modal/UPDATE_ICEPACK_FILLER';
export const updateIcepackFillerAction = payload => ({
	type: UPDATE_ICEPACK_FILLER,
	payload,
});

export const SET_IS_ICEPACK_FILLER_UPDATING = 'icepacks-fillers-modal/SET_IS_ICEPACK_FILLER_UPDATING';
export const setIsIcepackFillerUpdatingAction = payload => ({
	type: SET_IS_ICEPACK_FILLER_UPDATING,
	payload,
});

export const DELETE_ICEPACK_FILLER = 'icepacks-fillers-modal/DELETE_ICEPACK_FILLER';
export const deleteIcepackFillerAction = payload => ({
	type: DELETE_ICEPACK_FILLER,
	payload,
});

export const SET_IS_ICEPACK_FILLER_DELETING = 'icepacks-fillers-modal/SET_IS_ICEPACK_FILLER_DELETING';
export const setIsIcepackFillerDeletingAction = payload => ({
	type: SET_IS_ICEPACK_FILLER_DELETING,
	payload,
});

export const RESET_STATE = 'icepacks-fillers-modal/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
